<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'results.import.summaryTitle' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="row">
      @if (errors().length) {
        <div class="col-12">
          <div class="mb-3">
            <p class="caption mb-1">
              {{ 'results.import.errorsTitle' | translate }}
            </p>
            <hr class="mt-0" />
            <app-data-table [configuration]="errorsDataTableConfiguration" />
          </div>
        </div>
      } @else {
        <div class="col-12 col-md-4 border-end">
          @if (!isLoading()) {
            <b>{{ 'results.import.ImportInfo' | translate }}</b>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.laboratory' | translate }}
              </div>
              <div class="col-8">
                {{ import().laboratory }}
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.dataVersion' | translate }}
              </div>
              <div class="col-8">
                {{ import().dataVersion }}
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.fileName' | translate }}
              </div>
              <div class="col-8">
                <span
                  class="d-block overflow-hidden text-truncate text-nowrap"
                  [title]="getFileName()"
                >
                  {{ getFileName() }}
                </span>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.signee' | translate }}
              </div>
              <div class="col-8">
                {{ getSignee() }}
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.generated' | translate }}
              </div>
              <div class="col-8">
                {{ import().generated | date: 'MMM dd, y HH:mm' }}
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.generatedBy' | translate }}
              </div>
              <div class="col-8">
                <app-user-display [userId]="import().generatedBy" />
              </div>
            </div>
            <hr />
            <b>{{ 'results.import.ResultsInfo' | translate }}</b>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.generatedReports' | translate }}
              </div>
              <div class="col-8">
                {{ summary().generatedReportsCount }}
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.failedResults' | translate }}
              </div>
              <div class="col-8">
                {{ summary().failedResultsCount }}
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.highRiskReports' | translate }}
              </div>
              <div class="col-8">
                {{ summary().highRiskReportsCount }}
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.lowRiskReports' | translate }}
              </div>
              <div class="col-8">
                {{ summary().lowRiskReportsCount }}
              </div>
            </div>
            @for (
              reportType of Object.keys(summary().reportCountByType);
              track reportType
            ) {
              <div class="row pt-2">
                <div class="col-4">
                  <i>{{ reportType | translate }}</i>
                </div>
                <div class="col-8">
                  {{ summary().reportCountByType[reportType].length }}
                </div>
              </div>
            }
            <div class="row pt-2">
              <div class="col-4">
                {{ 'results.import.runs' | translate }}
              </div>
              <div class="col-8">
                {{ summary().joinedRuns }}
              </div>
            </div>
          }
        </div>
        <div class="col-12 col-md-8">
          <app-nav-tabset [tabs]="tabs" />
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-clear" (click)="dismiss()">
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>

<ng-template #statusTemplate let-data="row">
  @if (data.report.status === ReportStatus.Invalid) {
    <b class="text-danger">
      {{ data.report.status }}
    </b>
  } @else {
    {{ data.report.status }}
  }
</ng-template>

<ng-template #reportedRiskTemplate let-data="row">
  @if (data.report.reportedRisk) {
    @if (
      !isLowRiskReport(data.report.reportedRisk) ||
      isLowRiskReport(data.detectedRisk) !==
        isLowRiskReport(data.report.reportedRisk)
    ) {
      <b class="text-danger">
        {{ 'reports.risk.' + data.report.reportedRisk | translate }}
      </b>
    } @else {
      {{ 'reports.risk.' + data.report.reportedRisk | translate }}
    }
  }
</ng-template>

<ng-template #detectedRiskTemplate let-data="row">
  @if (data.detectedRisk) {
    @if (data.report.reportedRisk !== data.detectedRisk) {
      <b class="text-danger">
        {{ 'reports.risk.' + data.detectedRisk | translate }}
      </b>
    } @else {
      {{ 'reports.risk.' + data.detectedRisk | translate }}
    }
  }
</ng-template>

<ng-template #failedReasonTemplate let-data="row">
  <b class="text-danger">
    {{ data.failedReason }}
  </b>
</ng-template>

<ng-template #errorTemplate let-data="row">
  <b class="text-danger">
    {{ data.error }}
  </b>
</ng-template>

<ng-template #validResultsTemplate>
  <div class="d-block flex-grow-1 data-table-container">
    <app-data-table
      [configuration]="validDataTableConfiguration"
      (pageChanged)="validOnPageChanges($event)"
      (pageSizeChanged)="validOnPageSizeChanges($event)"
    />
  </div>
</ng-template>

<ng-template #invalidResultsTemplate>
  <div class="d-block flex-grow-1 data-table-container">
    <app-data-table
      [configuration]="invalidDataTableConfiguration"
      (pageChanged)="invalidOnPageChanges($event)"
      (pageSizeChanged)="invalidOnPageSizeChanges($event)"
    />
  </div>
</ng-template>
